import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { Panel } from '../../../../components/Layout/Panel';
import {
  Screen,
  SplitScreen,
  SplitScreenContentHolder
} from '../../../../components/Layout/Screen';
import Title, { Highlight, Subtext } from '../../../../components/Title';
import { AbsolutePositioned } from '../../../../components/Layout/AbsolutePositioned';

// Assets
import { brandColors, device } from '../../../../styles/variables';
import office from '../../../../assets/images/pages/neva/ARCADE-workshop-6.jpg';
import neva from '../../../../assets/images/pages/neva/neva-net.png';

const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
  background: url(${office});
  background-size: cover;
  padding-top: 1px;
  margin-top: -1px;

  .title {
    padding: 20px;
    @media ${device.tablet} {
      padding: 18px 34px;
    }
    @media ${device.laptopL} {
      padding: 80px;
    }

    h2 {
      max-width: 100%;
    }

    .subtext {
      max-width: 453px;
      font-size: 16px;
      line-height: 36px;
    }
  }

  .panel {
    width: 100%;
    height: 346px;
    @media ${device.tablet} {
      width: 50%;
      height: 50%;
    }
  }
`;

const BackgroundOverlay = AbsolutePositioned.extend`
  background: ${brandColors.white};
  width: 100%;
  height: 100%;
  opacity: 0.6;
`;

const ContentHolder = AbsolutePositioned.extend`
  width: 100%;
  height: 100%;
`;

const NevaImage = styled.img`
  width: 100%;
  max-width: 371px;
  display: block;
  margin: 0 auto;
`;

const StyledSplitScreen = SplitScreen.extend`
  width: 100%;
  height: 371px;

  @media ${device.tablet} {
    width: 50%;
    height: 100%;
  }

  .owl-image {
    img {
      margin-top: 100px;
    }
  }
`;

const HowWeDidItScreen = () => (
  <StyledScreen>
    <BackgroundOverlay />
    <ContentHolder>
      <StyledSplitScreen>
        <SplitScreenContentHolder className="owl-image">
          <NevaImage src={neva} />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
      <StyledSplitScreen>
        <Panel className="panel" top="unset" left="unset" right="0" bottom="0">
          <Title primary={false} className="title">
            How we <Highlight>did</Highlight> it
            <br />
            <br />
            <Subtext className="subtext">
              We started with a discovery workshop to help identify user stories for a UX-driven
              delivery. We then developed a brand name, mark and design language to fit the tone of
              the product.
            </Subtext>
          </Title>
        </Panel>
      </StyledSplitScreen>
    </ContentHolder>
  </StyledScreen>
);

export default connect()(HowWeDidItScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/MakingOfAnIndustryLeader/screens/HowWeDidIt.jsx